import React, { useMemo } from 'react';
import RatingStars from '../../../../../../../../components/RatingStars';
import Table from '../../../../../../../../components/Table';
import Place from '../../../../../../../../components/Place';
import { calcSum } from '../../../../../../../../utils/helpers';
import { useTranslation } from 'react-i18next';

const TableApplications = ({ applications }) => {
    const { t } = useTranslation()
    const columns = useMemo(
        () => [
            {
                Header: t('Obiekt'),
                accessor: 'object_name',
                Cell: ({ row, cell: { value } }) => (
                    <Place logo={row.original.object?.logo} name={value} />
                ),
            },
            {
                Header: t('Data świadczenia pracy'),
                accessor: 'date'
            },
            {
                Header: t('Stanowisko'),
                accessor: 'profession'
            },
            {
                Header: t('Godziny'),
                accessor: 'hours',
                Footer: info => {
                    return useMemo(
                        () => calcSum(info.rows, (row) => row.values?.hours),
                        [info.rows]
                    );
                },
            },
            {
                Header: t('Ocena ze zlecenia'),
                accessor: 'candidate_ranking',
                Cell: ({ cell: { value } }) => (
                    <RatingStars rate={value} small />
                ),
            },
            {
                Header: t('Koszt brutto'),
                accessor: "cost",
                Cell: ({row}) => {
                    return row.original.cost * row.original.hours;
                },
                Footer: (info) => {
                    return useMemo(
                        () => calcSum(info.rows, (row) => parseFloat(row.values?.cost * row.values?.hours).toFixed(2)),
                        [info.rows]
                    );
                },
            },
        ],
        [t]
    )

    const data = useMemo(() => applications, [applications]);
    return <Table columns={columns} data={data} />;
};

export default TableApplications;
